import posthog from 'posthog-js'

export const initPostHog = () => {
  const hash = window.location.hash.slice(1)
  const params = new URLSearchParams(hash)
  const distinctId = params.get('distinct_id') || undefined
  const sessionId = params.get('session_id') || undefined

  posthog.init(process.env.REACT_APP_POSTHOG_KEY!, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    capture_pageview: false,
    bootstrap: {
      ...(distinctId && { distinctID: distinctId }),
      ...(sessionId && { sessionID: sessionId }),
    },
  })
}

export const appendPostHogParams = (url: string): string => {
  const distinctId = posthog.get_distinct_id()
  const sessionId = posthog.get_session_id()
  if (!distinctId && !sessionId) return url
  return `${url}#distinct_id=${distinctId}&session_id=${sessionId}`
}
